<div class="main-head">
  <div class="left-container">
    <img src="assets/logo.png" alt="Logo" class="logo">
  </div>
  <div class="right-container">
    <div *ngFor="let menu of navigationItems; index as i"
         (click)="navigateToPage(i)"
         class="navigation-container"
    >
      {{ menu.title }}
    </div>

    <div (click)="logout()" style="cursor: pointer">
      <mat-icon fontIcon="logout"></mat-icon>
    </div>
  </div>
</div>

